import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export const getTimestampNow = () => firebase.firestore.Timestamp.now();
export const createTimestampFromDate = (date: Date) => firebase.firestore.Timestamp.fromDate(date);
export const createTimestampFromMilliseconds = (milliseconds: number) =>
  firebase.firestore.Timestamp.fromMillis(milliseconds);
export const createTimestamp = (seconds = 0, nanoseconds = 0) => new firebase.firestore.Timestamp(seconds, nanoseconds);
export const cloneTimestamp = (timestamp: firebase.firestore.Timestamp) =>
  new firebase.firestore.Timestamp(timestamp.seconds, timestamp.nanoseconds);
